import type { guide as enGuide } from "../en/guide";

export const guide: typeof enGuide = {
  heading: "Come funziona Quote Desk",
  intro:
    "Quote Desk trasforma le trattative di prezzo B2B in ordini bozza Shopify in tre passaggi. Ecco l'intero flusso, oltre alle risposte alle domande più comuni.",
  createFirstQuote: "Crea il tuo primo preventivo",
  threeStepFlowHeading: "Il flusso in tre passaggi",
  steps: {
    createQuoteTitle: "Crea un preventivo",
    createQuoteBody:
      "Scegli un'azienda B2B e un contatto, aggiungi i prodotti con prezzi personalizzati per riga e salva. Quote Desk gestisce per te valuta, sconti e imposte.",
    buyerAcceptsTitle: "L'acquirente esamina e accetta",
    buyerAcceptsBody:
      "Invia il preventivo e il tuo acquirente riceve un link email sicuro per visualizzarlo. Può accettare o rifiutare direttamente dal link — nessun account, nessun attrito.",
    draftOrderTitle: "Compare l'ordine bozza",
    draftOrderBody:
      "All'accettazione, Quote Desk crea automaticamente un ordine bozza B2B Shopify con i prezzi negoziati e l'entità di acquisto corretta — pronto per essere convertito.",
  },
  whatYouCanDoHeading: "Cosa puoi fare",
  features: {
    customPricingTitle: "Prezzi personalizzati per riga",
    customPricingBody:
      "Imposta qualsiasi prezzo su qualsiasi riga. Subtotale, sconti e imposte si ricalcolano automaticamente mentre lavori.",
    secureLinksTitle: "Link sicuri per l'acquirente",
    secureLinksBody:
      "Ogni link del preventivo è firmato e limitato a un singolo preventivo, con scadenza facoltativa — sicuro da inviare via email.",
    poParsingTitle: "Caricamento e analisi ordini d'acquisto",
    poParsingBody:
      "Carica l'ordine d'acquisto (PDF) di un cliente e Quote Desk ne estrae le righe con l'IA per preparare un preventivo in pochi secondi.",
    aiCounterOffersTitle: "Controfferte IA",
    aiCounterOffersBody:
      "Genera una controfferta intelligente basata sullo storico ordini dell'azienda quando un acquirente contesta il prezzo.",
    bulkImportTitle: "Importazione ed esportazione in blocco",
    bulkImportBody:
      "Importa preventivi da CSV ed esporta qualsiasi elenco filtrato — utile per migrazioni e reportistica.",
    followUpTitle: "Promemoria di follow-up",
    followUpBody:
      "La tua dashboard segnala i preventivi rimasti silenziosi (non visualizzati o senza decisione), così nessuna trattativa si blocca.",
  },
  faqHeading: "Domande frequenti",
  faq: {
    plusQ: "Mi serve Shopify Plus?",
    plusA: "No. Quote Desk funziona su tutti i piani che supportano le aziende B2B — non solo su Plus.",
    accountQ: "L'acquirente ha bisogno di un account?",
    accountA: "No. Gli acquirenti agiscono tramite un link email sicuro; non serve alcun accesso o registrazione.",
    acceptQ: "Cosa succede quando un acquirente accetta?",
    acceptA:
      "Registriamo l'accettazione e creiamo automaticamente un ordine bozza B2B Shopify con i prezzi negoziati.",
    reviseQ: "Posso modificare un preventivo dopo averlo inviato?",
    reviseA:
      "Usa Duplica per iniziare un preventivo rivisto, oppure invia una controfferta. I preventivi inviati restano bloccati per garantire una tracciabilità pulita.",
    whereQ: "Dove si trovano i miei preventivi?",
    whereA:
      "Tutti i preventivi sono elencati sotto Preventivi nel menu, dove puoi filtrare, esportare e aprire ciascuno per i dettagli completi.",
  },
};
